import EntityFormProvider from '@shared/components/forms/auto-form/entity-form-provider/entity-form-provider.vue';
import StdForm from '@shared/components/forms/auto-form/std-form/std-form.vue';
import Vue from 'vue';
import { Component, Prop, Watch } from 'vue-property-decorator';
import { Mandate } from '@accounting/interfaces/mandate';

@Component({
  name: 'bpc-mandate-form',
  components: {
    'bpc-std-form': StdForm,
  },
})
export default class MandateForm extends Vue {
  $refs: {
    // resourceForm: InstanceType<typeof ResourceForm> & { saveEntity(): void };
    stdForm: InstanceType<typeof StdForm> & {
      saveEntity(): void;
      formModel: any;
      onDeleteMediaFile(): void;
      searchEntity(): void;
      extraData: string | AnyEntity;
      formProvider: EntityFormProvider;
    };
  };
  @Prop([String, Number]) readonly entityId: string | number;
  @Prop([Object]) readonly value: AnyEntity;
  @Prop({ type: String, default: 'default' }) formConfigName: string;
  @Prop({ type: Boolean, default: false }) disabled: string;
  @Prop([Object]) extraData: AnyEntity;

  public entity: string = 'mandate';
  public permissionEntityNameToUse: string = 'mandates';
  public formModel: Mandate = null;

  // created() {}
  mounted() {
    this.$root.$on('changeContact', val => {
      this.$refs.stdForm.formModel.iban_number = val.iban_number;
      this.$refs.stdForm.formModel.bic_number = val.bic_number;
    });
  }

  destroyed() {
    this.$root.$off('changeContact');
  }

  onFormSaved(e) {
    this.$emit('entity-saved', e);
  }
  onSavingEntity(event) {
    this.$emit('saving-entity', event);
  }
  deleteMediaFile(mediaId) {
    this.$emit('delete-media-file', { mediaId: mediaId, entityId: this.entityId });
  }
  saveEntity() {
    this.$refs.stdForm.saveEntity();
  }

  setEntityAttributesAfterSave() {
    const newEntity = {} as Mandate;
    Object.keys(this.formModel).forEach(key => {
      this.$set(newEntity, key, null);
    });

    this.$set(this.$refs.stdForm, 'formModel', newEntity);
  }

  onEntityErrorSaving(e) {
    this.$emit('entity-error-saving', e);
  }

  @Watch('formModel', { immediate: true, deep: true })
  onFormModelChange() {
    this.$emit('input', this.formModel);
  }

  onModelLoaded(event) {
    this.$emit('model-loaded', event);
    // If it is a creation and there is extraFormModel and it comes from the subscription form, we create dynamically the name
    if (
      !this.entityId &&
      this.extraData?.externalFormModel &&
      this.formConfigName === 'default-from-subscription'
    ) {
      const subscriptionCategoryId = this.extraData.externalFormModel?.subscription_category_id;

      if (subscriptionCategoryId) {
        const categoryPath =
          this.$bpcApiRouteHelper.getEntityPath('subscription-category') +
          '/' +
          subscriptionCategoryId;

        this.$bpcApi.get(categoryPath).subscribe(
          categoryResponse => {
            this.$set(
              this.formModel,
              'name',
              `${this.extraData.externalFormModel?.code} - ${categoryResponse.data?.name}`,
            );
          },
          () => {
            this.$set(this.formModel, 'name', `${this.extraData.externalFormModel?.code}`);
          },
        );
      } else {
        this.$set(this.formModel, 'name', `${this.extraData.externalFormModel?.code}`);
      }
    }
  }
}
